import React, { useState, useEffect, useRef } from 'react'
import { Col, Row, Card, Button, Modal, ProgressBar } from 'react-bootstrap'
import axios from 'axios'
import ReactApexChart from "react-apexcharts";
import CampaignDetails from './campaigndetails'
import {Tab, Nav } from 'react-bootstrap';

function VoiceCampaigns(props) {
    const [campaigns, setCampaigns] = useState([])
    const [selectedCampaign, setSelectedCampaign] = useState(0)
    const [showsummary, setshowsummary] = useState(false)
    const [showdetails, setshowdetails] = useState(false)
    const [summary, setsummary] = useState({})
    const [detailedStats, setDetailedStats] = useState(null)

    useEffect(() => {
        if (showsummary && summary?.id) {
            setDetailedStats(null)
            axios.get(`/voicecampaign/${summary.id}/detailed-stats`)
                .then(result => setDetailedStats(result.data))
                .catch(err => console.log(err))
        }
    }, [showsummary, summary?.id])

    const formatResultLabel = (value) => {
        if (!value || value === 'N/A') return 'N/A';
        return value.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }

    const getcampaigns = () => {
        const url = `/voicecampaigns/${props.uid}`
        axios.get(url)
            .then(result => {
                result.data=result.data.map(row=>{
                    row.campaigncompleted=(parseInt(row.processed)===parseInt(row.totalnumbers))
                    // row.formattempted= calcSum([row.success, row.failed, row.formnotfound])
                    // row.totalleads=parseInt(row.leadscount-row.dnds);
                    return row
                })
                setCampaigns(result.data)
            })
            .catch(err => console.log(err))
    }

    const changeCampaignState = (crid, state) => {
        const url = `/changevoicecampaignstate/${crid}/${state}`
        axios.get(url)
            .then(result => {
                getcampaigns()
            })
            .catch(error => console.log(error))

    }

    const deleteCampaign = (id) => {
        if (!window.confirm('Delete this campaign? This cannot be undone.')) return
        axios.delete(`/voicecampaign/${id}`)
            .then(() => getcampaigns())
            .catch(error => console.log(error))
    }

    const recampaign = (id) => {
        if (!window.confirm('Retry all BUSY calls in this campaign? Their status will be reset so they get called again.')) return
        axios.post(`/voicecampaign/${id}/recampaign`)
            .then(result => {
                const count = result.data.affectedRows
                alert(`${count} BUSY record(s) have been reset and will be retried.`)
                getcampaigns()
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        getcampaigns()
    }, [props.tid, props.refresh])

    const calcprogress = (N, D) => {
        if (D) return Math.round((N / D) * 100)
        else return 100
    }

    const calcSum = list => {
        return list.reduce((sum, a)=> sum+parseInt(a), 0)
    }
    // console.log(summary);
    const limitText = (text) => {
        const limit=16
        return (text?.length > limit) ? text?.substring(0, limit) + '...' : text;
    }

    // Use a ref to always have the latest campaigns value inside the interval callback
    const campaignsRef = useRef(campaigns)
    useEffect(() => { campaignsRef.current = campaigns }, [campaigns])

    // Poll every 5 seconds only if any campaign is still running (not completed)
    useEffect(() => {
        const interval = setInterval(() => {
            const hasRunning = campaignsRef.current.some(c => !c.campaigncompleted && !c.ispaused)
            if (hasRunning) {
                getcampaigns()
            }
        }, 3000)
        return () => clearInterval(interval)
    }, [])

    return (
        <React.Fragment>
            <div className='w-100 h-100 d-flex flex-column overflow-hidden'>
            <Tab.Container defaultActiveKey="campaigns" activeKey="campaigns">
            <Nav variant='tabs' className='fs-6 border' >
                        <Nav.Item><Nav.Link eventKey="campaigns">Voice Campaigns</Nav.Link></Nav.Item>
                        <Nav.Item className='ms-auto'>
                            <Button title="Refresh" className={`btn btn-primary mx-1 float-right`} onClick={getcampaigns}><i class={`bi bi-arrow-repeat`}></i></Button>
                        </Nav.Item>
            </Nav>
            <Tab.Content className='w-100' style={{ height: "calc(100% - 34px)" }} animation={true} mountOnEnter={true} unmountOnExit={true} >
                        <Tab.Pane className='w-100 h-100' eventKey="campaigns" title="">
                            {/* <Campaigns setCampaignRefresh={setCampaignRefresh} refresh={campaignRefresh} uid={props.uid} tid={selectedTemplate} /> */}
                            <div className={`m-2`}  style={{maxHeight: "99%", display: 'grid', overflowX: 'hidden', overflowY: 'auto', gap: '4px', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))'}}>
                                {campaigns.map((row, index) => (
                                    <Col xs={1} className='m-1' style={{width: '100%', boxSizing: 'border-box'}}>
                                        <Card
                                            key={index}
                                            onClick={() => { setSelectedCampaign(row.id) }}
                                            className={`text-primary ${(index + 1 === selectedCampaign.id) ? `border-primary shadow-lg` : ''}`}
                                        >
                                            <Card.Header className={`text-white bg-${row.campaigncompleted ? 'success' : 'primary'} p-0 align-items-center`}>
                                                <div className="d-flex flex-row">
                                                    <div className="p-2"><span>{`Campaign [ID-${row.id}]`}</span></div>
                                                </div>
                                            </Card.Header>
                                            <Card.Body className='p-2 d-flex align-content-end flex-column'>
                                                <Card.Text>
                                                    {/* <Row className="mx-0 border-top"><Col xs={4} className="p-0"><b>Leads List</b></Col><Col className="ps-1" title={row.jname}>{!row.jname? row.customname :row.jname.length < 18 ? row.jname : row.jname?.substring(0, 15) + '...'}</Col></Row> */}
                                                    <Row className="mx-0 border-top"><Col xs={4} className="p-0"><b>Name</b></Col><Col className="ps-1" title={row.name}>{limitText(row.name)}</Col></Row>
                                                    <Row className="mx-0 border-top"><Col xs={4} className="p-0"><b>List</b></Col><Col className="ps-1" title={row.listname}>{limitText(row.listname)}</Col></Row>
                                                    <Row className="mx-0 border-top"><Col xs={4} className="p-0"><b>Started By</b></Col><Col className="ps-1">{limitText(row.startedby)}</Col></Row>
                                                    <Row className="mx-0 border-top"><Col xs={4} className="p-0"><b>Start Time</b></Col><Col className="ps-1">{limitText(row.starttime)}</Col></Row>
                                                    {(row.status === 1) ? '' : (
                                                        <Row className="mx-0 border-top"><Col xs={4} className="p-0"><b>End Time</b></Col><Col className="ps-1">{limitText(row.endtime)}</Col></Row>
                                                    )}
                                                    <Row className="mx-0 border-top border-bottom">
                                                        <Col xs={4} className="p-0"><b>Status</b></Col>
                                                        <Col className="ps-1">{
                                                        `${row.campaigncompleted ? `Completed `: row.ispaused===1 ? `Paused ` : `In Progress `} [${row.processed}/${row.totalnumbers}]  (${calcprogress(row.processed,row.totalnumbers)}%)`
                                                        }</Col>
                                                    </Row>
                                                </Card.Text>
                                                <Card.Text>
                                                    <ProgressBar now={calcprogress(row.processed,row.totalnumbers)} title={`${row.campaigncompleted  ? "Completed" : "In Progress"} (${calcprogress(row.processed,row.totalnumbers)}%)`} />
                                                </Card.Text>
                                                <Card.Text className={`m-0 p-0`}>
                                                    <Row className={`w-100 m-0`}>
                                                        <Col className="p-0 d-flex">
                                                            <Button title="Details" size="sm" variant="outline-primary" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={() => { setshowdetails(true) }}><i class="bi bi-clock-history"></i></Button>
                                                            <Button title="Summary" size="sm" variant="outline-primary" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={() => { setshowsummary(true); setsummary(campaigns[index]) }}><i class="bi bi-bar-chart-line"></i></Button>
                                                            <Button disabled={row.campaigncompleted ?  true : false} size="sm" variant="outline-primary" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={() => { changeCampaignState(row.id, row.ispaused ? 0 : 1) }}><i className={row.campaigncompleted ? "bi bi-check-circle" : row.ispaused ? "bi bi-play" : "bi bi-pause"}></i></Button>
                                                            
                                                            <Button title="Recampaign BUSY Calls" size="sm" variant="outline-warning" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={(e) => { e.stopPropagation(); recampaign(row.id) }}><i className="bi bi-arrow-repeat"></i></Button>

                                                            <Button title="Delete" size="sm" variant="outline-primary" style={{ borderRadius: "50%" }} className="me-1 border border-gray" onClick={(e) => { e.stopPropagation(); deleteCampaign(row.id) }}><i className="bi bi-trash"></i></Button>
                                                            
                                                        </Col>
                                                    </Row>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
            </Tab.Container>
            </div>

            <Modal show={showsummary} onHide={() => setshowsummary(false)} centered size="lg">
                <Modal.Header closeButton={true} >
                    <div className="fs-6">Campaign [ID-{summary.id} statistics]</div>
                </Modal.Header>
                <Modal.Body className="m-1 p-3" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {detailedStats ? (() => {
                        const baseCategories = ['Total Calls', 'Connected', 'Not Connected'];
                        const baseData = [
                            detailedStats.baseStats?.total_calls ?? 0,
                            detailedStats.baseStats?.connected_calls ?? 0,
                            detailedStats.baseStats?.not_connected_calls ?? 0
                        ];
                        const resultCategories = detailedStats.resultBreakdown
                            ? detailedStats.resultBreakdown.map(stat => stat.label || formatResultLabel(stat.result))
                            : [];
                        const resultData = detailedStats.resultBreakdown
                            ? detailedStats.resultBreakdown.map(stat => stat.count)
                            : [];
                        const allCategories = [...baseCategories, ...resultCategories];
                        const allData = [...baseData, ...resultData];
                        const chartHeight = (allCategories.length * 38 + 50) + 'px';

                        return (
                            <div>
                                <ReactApexChart
                                    options={{
                                        chart: { type: 'bar', toolbar: { show: false } },
                                        plotOptions: { bar: { borderRadius: 4, distributed: true, horizontal: true, barHeight: '80%' } },
                                        dataLabels: { enabled: true },
                                        xaxis: { categories: allCategories },
                                        legend: { show: false },
                                        yaxis: { labels: { style: { fontSize: '12px' } } },
                                    }}
                                    series={[{ name: "Calls", data: allData }]}
                                    type="bar"
                                    height={chartHeight}
                                />
                            </div>
                        );
                    })() : (
                        <div className="d-flex justify-content-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                </Modal.Body>

            </Modal>

            <Modal show={showdetails} onHide={() => setshowdetails(false)} centered size="xl" dialogClassName="my-modal">
                <Modal.Header closeButton={true}>
                    <div className="fs-6">Campaign [ID-{selectedCampaign} Details]</div>
                </Modal.Header>
                <Modal.Body className="m-1 p-2">
                    <CampaignDetails crid={selectedCampaign} isRunning={campaigns.some(c => c.id === selectedCampaign && !c.campaigncompleted && !c.ispaused)}/>                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}



export default VoiceCampaigns